import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import {
  Account,
  AccountService
} from "@onsip/common/services/api/resources/account/account.service";
import { MohAddressService } from "@onsip/common/services/api/resources/mohAddress/moh-address.service";
import { OrganizationService } from "@onsip/common/services/api/resources/organization/organization.service";
import { views } from "@onsip/web/app/phone/views";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "onsip-enabled-services",
  templateUrl: "./enabled-services.component.html",
  styleUrls: ["./enabled-services.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EnabledServicesComponent implements OnInit {
  views = views;
  e911Enabled!: Observable<boolean>;
  blfEnabled!: Observable<boolean>;
  mohEnabled!: Observable<boolean>;
  extendedDialing!: Observable<boolean>;
  internationalDialingUrl = "https://info.onsip.com/hubfs/OnSIP-Extended-Dialing-Form-1.pdf";
  accountInfo$!: Observable<Account>;

  constructor(
    private organizationService: OrganizationService,
    private mohService: MohAddressService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.mohService.mohAddressBrowse();
    this.e911Enabled = this.organizationService.orgState.pipe(
      map(state => state[0].e911Provisioning)
    );
    this.blfEnabled = this.organizationService.orgState.pipe(map(state => state[0].busyLampField));
    this.mohEnabled = this.mohService.orgState.pipe(map(state => !!state[0].maxChannels));
    this.extendedDialing = this.organizationService.orgState.pipe(
      map(state => state[0].extendedDialing)
    );
    this.accountInfo$ = this.accountService.accountState.pipe(map(accounts => accounts[0]));
  }
}
